var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_17520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1211 20.0898C15.4498 20.0898 19.7695 15.7701 19.7695 10.4414C19.7695 5.11272 15.4498 0.792969 10.1211 0.792969C4.79241 0.792969 0.472656 5.11272 0.472656 10.4414C0.472656 15.7701 4.79241 20.0898 10.1211 20.0898Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3695 10.4414C19.3695 15.5492 15.2289 19.6898 10.1211 19.6898C5.01332 19.6898 0.872656 15.5492 0.872656 10.4414C0.872656 5.33363 5.01332 1.19297 10.1211 1.19297C15.2289 1.19297 19.3695 5.33363 19.3695 10.4414Z",
    stroke: "#222222",
    strokeOpacity: 0.4,
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8652 7.69727L7.37695 13.1855",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37695 7.69727L12.8652 13.1855",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_17520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2969,
    height: 19.2969,
    fill: "white",
    transform: "translate(0.472656 0.792969)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.66d9a70317f8c15387edf9c6e382f26c.svg";
export { ForwardRef as ReactComponent };